// Content Radar request factory.
//
// Every Content Radar and integration endpoint uses the WorkspaceID header
// that `useRequest` already sends. The URL does not repeat the workspace id.
//
// Every request sets `disableLoading` because the Content Radar pages manage
// their own loading states, and the scan poller must never flash the global
// spinner every three seconds.

export const createGetIntegrationDefinitionsRequest = () => ({
  url: "/integrations/definitions",
  method: "GET",
  disableLoading: true,
});

export const createGetIntegrationConnectionsRequest = () => ({
  url: "/integrations/connections",
  method: "GET",
  disableLoading: true,
});

export const createIntegrationConnectLinkRequest = (
  integrationKey
) => ({
  url: `/integrations/${integrationKey}/connect_link`,
  method: "POST",
  disableLoading: true,
});

export const createVerifyIntegrationConnectionRequest = (
  connectionId
) => ({
  url: `/integrations/connections/${connectionId}/verify`,
  method: "POST",
  disableLoading: true,
});

export const createDisconnectIntegrationConnectionRequest = (
  connectionId
) => ({
  url: `/integrations/connections/${connectionId}`,
  method: "DELETE",
  disableLoading: true,
});

export const createGetIntegrationConnectionSpacesRequest = (connectionId) => ({
  url: `/integrations/connections/${connectionId}/spaces`,
  method: "GET",
  disableLoading: true,
});

export const createUpdateIntegrationConnectionSpacesRequest = (
  connectionId,
  spaceIds
) => ({
  url: `/integrations/connections/${connectionId}/spaces`,
  method: "PUT",
  data: { space_ids: spaceIds },
  disableLoading: true,
});

export const createListContentRadarScansRequest = () => ({
  url: "/content_radar/scans",
  method: "GET",
  disableLoading: true,
});

export const createContentRadarScanRequest = (
  { windowStart, windowEnd, integrationConnectionIds = [] } = {}
) => ({
  url: "/content_radar/scans",
  method: "POST",
  data: {
    scan: {
      window_start: windowStart,
      window_end: windowEnd,
      integration_connection_ids: integrationConnectionIds,
    },
  },
  disableLoading: true,
});

export const createGetContentRadarScanRequest = (scanId) => ({
  url: `/content_radar/scans/${scanId}`,
  method: "GET",
  disableLoading: true,
});

export const createCancelContentRadarScanRequest = (scanId) => ({
  url: `/content_radar/scans/${scanId}/cancel`,
  method: "POST",
  disableLoading: true,
});

export const createGetContentRadarReportRequest = (scanId) => ({
  url: `/content_radar/scans/${scanId}/report`,
  method: "GET",
  disableLoading: true,
});

export const createContentRadarPostCastSessionRequest = (
  opportunityId
) => ({
  url: `/content_radar/opportunities/${opportunityId}/postcast_session`,
  method: "POST",
  disableLoading: true,
});
